import React from 'react';
import Chip from '@ui/Chip';
import useUserProfile from '@/hooks/useUserProfile';
import { getUserCountry } from '@/utils/user.helper';
import PostType, { CampaignType } from 'constants/postType.constants';
import ClickableTooltip from '@/components/Styled/ClickableTooltip';

const getTaxBenefitTooltip = (nonProfitCountry) => {
  if (nonProfitCountry === 'IN') {
    return '80G tax benefit for INR donations (IN residents)';
  }
  return 'Tax benefit for USD donations (US residents)';
};

const getPostTypeInfo = (
  postType,
  campaignType,
  fundRaiseType,
  crowdFundType,
  user,
) => {
  const userCountry = getUserCountry(user);
  switch (postType) {
    case PostType.Campaign:
      if (campaignType === CampaignType.FundRaise) {
        const name =
          fundRaiseType === CampaignType.P2PFundRaise
            ? 'Fundraise with Friends'
            : `Fundraiser for ${userCountry === 'IN' ? 'NGO' : 'Nonprofit'}`;
        return {
          name: name,
          color: 'secondarydark',
        };
      } else if (campaignType === CampaignType.CollectGoods) {
        return {
          name: 'In-Kind Fundraiser',
          color: 'primarydark',
        };
      }
      return null;
    case PostType.Volunteering:
      return {
        name: 'Volunteering Opportunity',
        color: 'tomato',
      };
    case PostType.Project:
      return {
        name: 'Project',
        color: 'mulberry',
      };
    case PostType.CrowdFunding:
      const name =
        crowdFundType === 'organization'
          ? 'Fundraiser for an Organization'
          : 'Fundraiser for an Individual';
      return {
        name: name,
        color: 'secondarydark',
      };

    default:
      return null;
  }
};

function PostTypeIndicatorChip(props) {
  const { postType, campaignType, fundRaiseType, crowdFundType, nonProfit } =
    props;
  const user = useUserProfile();
  const postTypeInfo = getPostTypeInfo(
    postType,
    campaignType,
    fundRaiseType,
    crowdFundType,
    user,
  );

  const taxBenefitInfo = {
    name: 'Tax Benefit',
    color: 'kellyGreen',
    tooltip: getTaxBenefitTooltip(nonProfit?.country),
  };

  if (postTypeInfo) {
    return (
      <div className="flex gap-4">
        <Chip color="secondary" text="small">
          {postTypeInfo.name}
        </Chip>
        {campaignType === CampaignType.FundRaise && (
          <Chip
            // title={taxBenefitInfo.tooltip}
            className="flex cursor-pointer justify-center gap-1"
            color="secondary"
            text="small">
            {taxBenefitInfo.name}
            <ClickableTooltip message={taxBenefitInfo.tooltip} />
          </Chip>
        )}
      </div>
    );
  }
  return null;
}

export default PostTypeIndicatorChip;
